export { TendermintProxyService } from '../../gen/penumbra/util/tendermint_proxy/v1/tendermint_proxy_connect.js';
